import {Injectable} from '@angular/core';
import {catchError, forkJoin, Observable, shareReplay, throwError} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {HttpClientService} from '../http-client/http-client.service';
import {map} from 'rxjs/operators';
import {EnvironmentService} from '../environment/environment.service';
import {KnowledgeDocumentRessourceDto} from './knowledge-document-ressource-dto';
import {KnowledgeDocumentContent} from '../../model/knowledge-document-content';
import {environment} from 'projects/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeStorageService {

  private readonly htmlResourceTemplate = (documentId: string): string => `${environment.knowledgeHelpCenterBaseUrl}documents/${documentId}/extern`;
  private readonly cssResource = `${environment.knowledgeCommonBaseUrl}resources/KnowledgeDocument.css`;

  private cachedCss$: Observable<string> | null = null;

  constructor(
    private readonly httpClientService: HttpClientService,
    private readonly environmentService: EnvironmentService
  ) { }

  getContent(documentId: string): Observable<KnowledgeDocumentContent> {
    const html$ = this.getHtml(documentId);
    const css$ = this.getCss();

    return forkJoin([html$, css$]).pipe(
      map(([html, css]) => ({ html, css }))
    );
  }

  private getHtml(documentId: string): Observable<string> {

    if (!this.environmentService.production) {
      documentId = '1019980'; // auf DEV und QS sind nur wenige Dokumente vorhanden
    }

    return this.httpClientService
      .get<KnowledgeDocumentRessourceDto>(this.htmlResourceTemplate(documentId), true)
      .pipe(
        map((resp: HttpResponse<KnowledgeDocumentRessourceDto>) => resp.body?.content || ''),
        shareReplay(1)
      );

  }

  private getCss(): Observable<string> {
    if (!this.cachedCss$) {
      this.cachedCss$ = this.httpClientService
        .getText(this.cssResource)
        .pipe(
          catchError((error) => {
            // Cache zurücksetzen, damit bei erneutem Aufruf ein neuer Request gemacht wird
            this.cachedCss$ = null;
            return throwError(() => error);
          }),
          shareReplay(1)
        );
    }
    return this.cachedCss$;
  }

}
